import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import ModalWrapper from 'Common/Components/ModalWrapper';
import useModalShortcuts from 'Hooks/useModalShortcuts';
import {
  ModalTitle,
  Title,
  ModalContent,
  ButtonsContainer,
  ConfirmButton,
  CancelButton,
  Warning,
  ModalBody,
  WarningText,
  EditorWrapper
} from './styled';

const EditVulnerabilityCVEModal = ({
  show,
  title,
  editor,
  showGroupingWarning,
  onClose,
  onSave,
  saveDisabled
}) => {
  useModalShortcuts({
    id: 'vuln-cve-edit', visible: show, onSave, onCancel: onClose, canSave: !saveDisabled
  });

  if (!show) return null;

  const modalContent = (
    <ModalWrapper>
      <ModalContent>
        <ModalTitle>
          <Warning />
          <Title>{title}</Title>
        </ModalTitle>

        <ModalBody>
          {showGroupingWarning && (
            <WarningText>
              This vulnerability belongs to a workspace where “Group by CVE” is enabled.
              {' '}
              Changing this field may trigger automatic regrouping of vulnerability.
            </WarningText>
          )}

          <EditorWrapper>
            {editor}
          </EditorWrapper>
        </ModalBody>

        <ButtonsContainer>
          <CancelButton onClick={ onClose }>Cancel</CancelButton>
          <ConfirmButton onClick={ onSave } disabled={ saveDisabled }>Save</ConfirmButton>
        </ButtonsContainer>
      </ModalContent>
    </ModalWrapper>
  );

  if (typeof document === 'undefined') return modalContent;
  return createPortal(modalContent, document.body);
};

EditVulnerabilityCVEModal.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  editor: PropTypes.node,
  showGroupingWarning: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  saveDisabled: PropTypes.bool
};

EditVulnerabilityCVEModal.defaultProps = {
  show: false,
  title: 'Edit Vulnerability CVE',
  editor: null,
  showGroupingWarning: false,
  onClose: () => {},
  onSave: () => {},
  saveDisabled: false
};

export default EditVulnerabilityCVEModal;
